import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useHybrisSegment } from '@telialt/utils/src/segment';

import { SearchSuggestionClickHandler, SearchSuggestionItemWithQueryKey } from '../../../model';
import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { getSearchResultsPath } from '../../../utils/paths';
import { ListSuggestions } from '../../ListSuggestions/ListSuggestions';
import { ListSuggestionItemProps } from '../../ListSuggestions/model';
import { SectionHeading } from '../SearchSuggestions.styles';

type Props = {
    suggestions: SearchSuggestionItemWithQueryKey[];
    searchText?: string;
    onClick?: SearchSuggestionClickHandler;
};

const SEARCH_SUGGESTIONS_AUTO_COMPLETE = 'search-suggestions-auto-complete';

export const AutoComplete: FC<Props> = ({ suggestions, searchText, onClick }) => {
    const { t } = useTranslations();

    const segment = useHybrisSegment();

    if (!suggestions.length) {
        return null;
    }

    const items: ListSuggestionItemProps[] = suggestions.map((item) => {
        return {
            keyword: item.suggestion,
            searchText,
            url: getSearchResultsPath(segment, item.suggestion),
            queryKey: item.queryKey,
        };
    });

    return (
        <section data-test={SEARCH_TEST_ID.SUGGESTIONS_AUTOCOMPLETE} aria-labelledby={SEARCH_SUGGESTIONS_AUTO_COMPLETE}>
            <SectionHeading tag="h2" variant="title-100" id={SEARCH_SUGGESTIONS_AUTO_COMPLETE}>
                {t['search.suggestions.recommended.title']}
            </SectionHeading>
            <ListSuggestions items={items} onClick={onClick} />
        </section>
    );
};
